module.exports = __webpack_public_path__ + "img/minus.c771cb93.svg";